/**
 * This is used in the template to keep the original order
 * of an object when we are looping through it.
 */
export function originalKeyValueOrder(): number {
    return 0;
}
